import Vue from 'vue';

export const EVENT_BUS_EVENTS = {
    PUBLISH: 'PUBLISH',
    SET_ASSET_DATA: 'SET_ASSET_DATA',
};

export const EventBus = new Vue();
